import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaViewPage.vue?vue&type=template&id=357d7e04"
import script from "./RsaConfigurazioneAttivitaViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports